import React from 'react';
import { CtaButton } from '../CtaButton';
import { Countdown } from '../Countdown';
import { ScarcityBar } from '../ScarcityBar';
export function FinalCall() {
  return <section className="w-full bg-ink px-4 py-14 sm:px-6 sm:py-20" data-id="element-169" data-mp="hcb13bshxl6f">
      <div className="mx-auto w-full max-w-2xl" data-id="element-170" data-mp="3ijw8gppmph1">
        <div className="text-center" data-id="element-171" data-mp="7k575wiootol">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.24em] text-blood" data-id="element-172" data-mp="7j3vbptug35t">
            🔥 Final call
          </p>
          <h2 className="mt-3 font-display text-[26px] font-extrabold leading-tight text-white sm:text-4xl" data-id="element-173" data-mp="3psmk3503273u">
            The next time a patient with hypertension walks into your
            consultation, you’ll have two choices
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-4 text-[15px] leading-relaxed text-white/75 sm:text-base" data-id="element-174" data-mp="3kryhdm2hs1ts">
          <p data-id="element-175" data-mp="1eyqf23lps0p8">
            You can continue jumping between different guidelines, trying to
            remember which recommendation applies…
          </p>
          <p className="border-l-2 border-blood pl-4 font-medium text-white" data-id="element-176" data-mp="3jozyf3z9pcgn">
            Or you can follow a clinical route that has already organized the
            decision for you. What to do. When to do it. And what to consider
            next.
          </p>
          <p data-id="element-177" data-mp="3th5m41ihl7q1">
            The decision you make today can become the system you rely on across
            hundreds of future consultations.
          </p>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-178" data-mp="30r6v40kqf0iq">
          <CtaButton label="I want Hypertension Route for only $27 USD" subline="Instant access · One-time payment · 7-day guarantee · Automatic currency conversion" variant="light" data-id="element-179" data-mp="2vrc5e0cp0gz9" />
        </div>

        <div className="mt-10 rounded-2xl bg-graphite/60 p-5 ring-1 ring-white/10 sm:p-7" data-id="element-180" data-mp="35op5zwib7ptd">
          <Countdown tone="dark" data-id="element-181" data-mp="pxb2jynjuml0" />
          <div className="mt-6" data-id="element-182" data-mp="q0gqvboctkfo">
            <ScarcityBar tone="dark" data-id="element-183" data-mp="kzj8axzfmodn" />
          </div>
        </div>
      </div>
    </section>;
}